import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export abstract class AnmalanTradslagBaseCommand extends BasicCommand<AnmalanTradslagBaseCommand> {
    anmalanTradslagGuid: string;
    atgardGuid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "AnmalanTradslag";

    get primaryKey(): IAnmalanTradslagPrimaryKey {
        return {
            anmalantradslagGuid: this.anmalanTradslagGuid,
            atgardGuid: this.atgardGuid
        };
    }

    constructor(atgardGuid: string, anmalantradslagGuid: string, $type: string, commandType: CommandType) {
        super($type, AnmalanTradslagBaseCommand.$groupKey, commandType);
        this.atgardGuid = atgardGuid;
        this.anmalanTradslagGuid = anmalantradslagGuid;
    }
}

export interface IAnmalanTradslagPrimaryKey extends IPrimaryKey<IAnmalanTradslagPrimaryKey> {
    anmalantradslagGuid: string;
    atgardGuid: string;
}
